export default class Command {
    constructor(item) {
        this.id = item != null ? item.id : '';
        this.name = item != null ? item.name : '';
        this.agreementType = item != null ? item.agreementType : [];
        this.typeName = item != null ? item.typeName : '';
        this.agreementPrice = item != null ? item.agreementPrice : [];
        this.startdate = item != null ? item.startdate : '';
        this.enddate = item != null ? item.enddate : '';
        this.isVariable = item != null ? item.isVariable : false;
        this.cycle = item != null ? item.cycle : 1;
    }
}